export function  transformDate(inputDate, datePipe) {
    const date1 = datePipe.transform(inputDate, 'short');
    const date = datePipe.transform(date1, 'yyyy-MM-dd');
    return date;
}

export function  isTokenExpired(token: string): boolean {
  if(!token || token.split('.').length < 2) 
    return true;
  const expiry = JSON.parse(atob(token.split('.')[1])).exp;
  const utcNow = new Date().getTime();
  const end = (expiry/60).toFixed();
  const start = (utcNow/(60*1000)).toFixed();
  return (expiry * 1000) < new Date().getTime();
}